import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import ScrollerHOC from "./utils/ScrollerHOC";

// Styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "tailwindcss/tailwind.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";

import "ag-grid-community/styles//ag-grid.css";
import "ag-grid-community/styles//ag-theme-alpine.css";

import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import "react-tippy/dist/tippy.css";
import "./assets/CSS/index.css";
import "./localization/index";
import "react-toastify/dist/ReactToastify.css";
import "react-virtualized/styles.css";

import App from "./App";
import { BrowserRouter } from "react-router-dom";

// Sentry Integration
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// Grafana integration
import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { UserContextProvider } from "./lib/MainContext";
import SplashScreenView from "./views/Shared/SplashScreenView";
import { ToastContainer } from "react-toastify";

TimeAgo.addDefaultLocale(en);

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
});

initializeFaro({
    url: process.env.REACT_APP_GRAFANA_URL,
    app: {
        name: process.env.REACT_APP_GRAFANA_NAME,
        version: "1.0.0",
        environment: "production",
    },
    instrumentations: [
        // Mandatory, overwriting the instrumentations array would cause the default instrumentations to be omitted
        ...getWebInstrumentations(),

        // Initialization of the tracing package.
        // This packages is optional because it increases the bundle size noticeably. Only add it if you want tracing data.
        new TracingInstrumentation(),
    ],
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Suspense fallback={<SplashScreenView />}>
                <UserContextProvider>
                    <ScrollerHOC>
                        <App />
                        <ToastContainer limit={3} />
                    </ScrollerHOC>
                </UserContextProvider>
            </Suspense>
        </BrowserRouter>
    </React.StrictMode>
);
